const chipClasses = '';

const chipCommonClasses = {
  chipClasses,
};

export default chipCommonClasses;
